import React from 'react';
import { Field, reduxForm } from 'redux-form';
import label from '../../utils/lngEn';
import FormField from '../common/FormField';
import Validate from '../common/formValidate';
import { Modal, Row, Col } from 'react-bootstrap';
import DropdownList from 'react-widgets/lib/DropdownList';

const renderDropdownList = ({ input, meta: { touched, error }, ...rest }) => (
  <div>
    <DropdownList {...input} {...rest} />
    <div>{touched && (error && <span className="text-danger">{error}</span>)}</div>
  </div>
);

const validate = values => {
  const errors = {};
  if (values.startdate && !values.enddate) {
    errors.enddate = 'Both Start and End date are required';
  } else if (!values.startdate && values.enddate) {
    errors.startdate = 'Both Start and End date are required';
  }
  return errors;
};

const AddMeetingForm = props => {
  const { handleSubmit, submitting, onCancel } = props;
  return (
    <form onSubmit={handleSubmit} className="mt-4">
      <Field name="id" id="meetingId" component="input" type="hidden" />
      <div className="form-group">
        <label htmlFor="limit">Day</label>
        <Field
          name="day"
          valueField="value"
          textField="option"
          data={[
            { option: 'Monday', value: '1' },
            { option: 'Tuesday', value: '2' },
            { option: 'Wednesday', value: '3' },
            { option: 'Thursday', value: '4' },
            { option: 'Friday', value: '5' },
            { option: 'Saturday', value: '6' },
            { option: 'Sunday', value: '7' }
          ]}
          validate={[Validate.Required]}
          component={renderDropdownList}
        />
        <span className="input-description">Select a Day from the dropdown.</span>
      </div>

      <div className="form-group">
        <label htmlFor="location">Location</label>
        <Field
          name="location"
          type="text"
          component={FormField}
          validate={[Validate.StringRange50]}
          description={label.meetingFormLocationDesc}
        />
      </div>
      <Row>
        <Col md={6}>
          <div className="form-group">
            <label htmlFor="starttime">Start Time</label>
            <Field
              name="starttime"
              type="time"
              component={FormField}
              validate={[Validate.Required]}
              description="Enter start time"
            />
          </div>
        </Col>
        <Col md={6}>
          <div className="form-group">
            <label htmlFor="endtime">End Time</label>
            <Field
              name="endtime"
              type="time"
              component={FormField}
              validate={[Validate.Required]}
              description="Enter end time"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <div className="form-group">
            <label htmlFor="startdate">Start Date</label>
            <Field name="startdate" type="date" component={FormField} description="Enter start date" />
          </div>
        </Col>
        <Col md={6}>
          <div className="form-group">
            <label htmlFor="enddate">End Date</label>
            <Field name="enddate" type="date" component={FormField} description="Enter end date" />
          </div>
        </Col>
      </Row>
      <Modal.Footer className="mt-4">
        <button type="button" onClick={onCancel} className="btn  btn-ter pull-left">
          Cancel
        </button>
        <button className="btn btn-primary pull-right" type="submit" disabled={submitting}>
          Save
        </button>
      </Modal.Footer>
    </form>
  );
};

export default reduxForm({
  form: 'AddMeetingForm',
  validate
})(AddMeetingForm);



// WEBPACK FOOTER //
// ./src/components/classes/AddMeetingForm.js